import { Action } from "@iva/store-utils";
import { TableContextResponse } from "#services/pilotService/types";

export enum TablecontextActions {
    REQUESTED_FETCH = "@@tablecontext/requested-fetch",
    FETCHED_CONTEXT = "@@tablecointext/fetch",
    FAILED_FETCH = "@@tablecontext/failed-fetch",
    START_FETCH = "@@tablecontext/start-fetch",
}

type TableContextStartFetchAction = Action<
    TablecontextActions.START_FETCH,
    undefined
>;
type TableContextFetchedContextAction = Action<
    TablecontextActions.REQUESTED_FETCH,
    undefined
>;
type TablecontextFailedAction = Action<
    TablecontextActions.FAILED_FETCH,
    undefined
>;
type TableContextRequestedFetchAction = Action<
    TablecontextActions.FETCHED_CONTEXT,
    TableContextResponse
>;
export type TablecontextActionTypes =
    | TableContextStartFetchAction
    | TableContextFetchedContextAction
    | TablecontextFailedAction
    | TableContextRequestedFetchAction;
export type TableContextState = {
    contexts: TableContextResponse[];
};
